let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("36RqN")).then(() => parcelRequire('1KSRk'));